import { render, staticRenderFns } from "./couponsDialog.vue?vue&type=template&id=51c86688&scoped=true"
import script from "./couponsDialog.vue?vue&type=script&lang=js"
export * from "./couponsDialog.vue?vue&type=script&lang=js"
import style0 from "./couponsDialog.vue?vue&type=style&index=0&id=51c86688&prod&lang=scss&scoped=true"
import style1 from "./couponsDialog.vue?vue&type=style&index=1&id=51c86688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c86688",
  null
  
)

export default component.exports